import { render, staticRenderFns } from "./RegistroTramiteAdministrativoSection.vue?vue&type=template&id=22ce4c1c"
import script from "./RegistroTramiteAdministrativoSection.vue?vue&type=script&lang=js"
export * from "./RegistroTramiteAdministrativoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports